import { nl } from "./nl";

/** The till speaks Dutch for now; French and English are added as files next to nl.ts. */
export const t = nl;
